// extracted by mini-css-extract-plugin
export default {"card":"_E41KCGCWewkmPntFaa_","version":"hmOBgeLbiHAHfvdVgTT6","actions":"M5nXjdRlbDnrurcY6eJH","import":"SESsqOh4doKOJafvVEzH"};